import LicenseOrCertificationForm from './LicenseOrCertificationForm';

export default LicenseOrCertificationForm;
